import React from 'react';
import { string, object, number } from 'prop-types';

const SVG = ({ filePath, id, width, height }) => {
  require(`../../${filePath}/${id}.svg`); // TODO: Fix this relative path

  return (
    <svg width={width} height={height} >
      <use xlinkHref={`#${id}`} fill={ '#333333' } />
    </svg>
  );
};

SVG.propTypes = {
  filePath: string,
  id: string,
  width: number,
  height: number,
  styles: object
};

export default SVG;



// WEBPACK FOOTER //
// ./src/uis/common/SVG/SVG.js